import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ChatFragment = { id: string, name: string, createdAt: string };


export type ChatFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ChatFragmentDoc = /*#__PURE__*/ gql`
    fragment Chat on ChannelType {
  id
  name
  createdAt
}
    `;